import { createSelector } from 'reselect'

import { RootState } from 'redux/store'
import { LegislationFolderCategory } from 'interfaces/legislation'

const selectLegislationFoldersMap = createSelector(
  (state: RootState) => state.legislation.foldersMap,
  (foldersMap: Record<string, LegislationFolderCategory[]>) => foldersMap
)

export default selectLegislationFoldersMap
